// 页面样式
import css from 'css/page/giftDetail.scss'

// 公共方法
import {
  domObserver,
  headerInit,
  memberShip,
  qrcode,
} from 'js/common/index'
// 工具方法
import * as utils from 'js/utils/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts() {
  memberFormInit()
}

/**
 * 登录相关表单初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

// 二维码初始化
function QRCodeInit() {
  let parser = new utils.UrlParser()

  qrcode.init({
    ht: 120,
    target: '.sec-intro .top .yui-card0halign-actionbox .qrcode',
    wt: 120,
  })
  qrcode.init({
    ht: 140,
    prefix: parser.domainName,
    target: '.sec-summary .yui-qrbtn0 .qrcode',
    wt: 140,
  })
}

/**
 * UI 初始化
 */
function uiInit() {
  QRCodeInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})


// WEBPACK FOOTER //
// ./js/page/giftDetail.js